import { flights } from "./constants";

import axios from "../axios";

export const getOnlineTable = (language, params) => {
    let { flight_type, date, query } = params
    return async dispatch => {
        try {
            dispatch({ type: flights.GET_ARRIVAL_FLIGHTS_REQUEST });
            const res = await axios.get(`${language}/api/${flight_type}/${date}?query=${query}`);
            if (res.status === 200 || res.status === 201) {
                dispatch({
                    type: flights.GET_ARRIVAL_FLIGHTS_SUCCESS,
                    payload: {
                        arrival_flights_: res.data.results
                    }
                });
            }
        } catch (error) {
            dispatch({ type: flights.GET_ARRIVAL_FLIGHTS_FAILURE })
        }
    }
}